module.exports = __webpack_public_path__ + "static/img/hasNo.e00fab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hasNo.png
// module id = S9P8
// module chunks = 1